import React from 'react';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  InputBase,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import cx from 'classnames';
const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      //  marginTop: theme.spacing(1),
    },
    '&.hasValue select': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
  input: {
    borderRadius: 4,
    color: theme.palette.primary.main,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.light}`,
    padding: theme.spacing(1, 2),
    '&:focus': {
      borderRadius: 4,
      borderColor: theme.palette.primary.dark,
    },
    '@global': {
      'option, optgroup': {
        color: theme.palette.text.primary
      }
    }
  },
}))(InputBase);

export function AttributeFilter(props) {
  const { id, label, value, onChange, options, emptyLabel, noEmpty } = props;
  return (
    <FormControl variant="outlined">
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        native
        inputProps={{
          name: label,
          id: id,
        }}
        value={value}
        onChange={e => onChange(id, e.target.value)}
        label={label}
        input={
          <BootstrapInput
            className={cx({ hasValue: !!value && value !== '' })}
          />
        }
      >
        {!noEmpty && <option value="">{emptyLabel}</option>}
        {options?.map(o => {
          if (o.options) {
            return (
              <optgroup key={o.label} label={o.label}>
                {o.options.map(oo => (
                  <option key={oo.label} value={oo.value}>
                    {oo.label}
                  </option>
                ))}
              </optgroup>
            );
          }
          return (
            <option key={o.label} value={o.value}>
              {o.label}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
}
